import { Component, ViewEncapsulation } from '@angular/core';
import { ToastaConfig, ToastaModule } from 'ngx-toasta';

@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [ToastaModule]
})
export class ToasterComponent {

  constructor(
    private toastaConfig: ToastaConfig
  ) {
    this.toastaConfig.timeout = 4000;
    this.toastaConfig.position = 'bottom-left';
  }

}
